export enum SpecialNeedType {
  SpecialClassOrEducationalGroup = 1,
  ExtendedProfessionalProcedure, // PSP
  SpecialCenter, // Centers authorized by MZO
  SpecialCenterExtendedProfessionalProcedure // PSP and Centers authorized by MZO
}
